import { useMemo } from 'react';

import { usePortalLocalization } from '../../hooks/portal';

export const useLocalizationsById = () => {
    const { data: localizations, isLoading } = usePortalLocalization();

    const localizationsById = useMemo(() => {
        if (!localizations) return undefined;
        const map: Record<string, Record<string, string>> = {};
        for (const localization of localizations) {
            if (!map[localization.id]) {
                map[localization.id] = {};
            }
            map[localization.id][localization.language] =
                localization.translation;
        }
        return map;
    }, [localizations]);

    return { localizationsById, isLoading };
};
